
import React from 'react';
import { ActionCardProps } from '@/types/action-card';
import { ActionCardBase } from './ActionCardBase';
import { cn } from '@/lib/utils';

export const ApiActionCard = (props: ActionCardProps) => {
  // Add API-specific styling or behavior here
  return (
    <ActionCardBase 
      {...props} 
      className={cn(
        "border-l-4 border-l-primary/40",
        props.className
      )}
    />
  );
};
